import { h } from '@stencil/core';

const Icon = ({ width = '100%', height = '100%' }) => {
  return (
    <svg width={width} height={height} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512">
      <g>
        <g>
          <path
            fill="#011111"
            d="M77.679,230.865c0.603,1.287,1.401,2.331,2.396,3.131c0.995,0.797,2.164,1.389,3.507,1.776
			s2.73,0.581,4.164,0.581c0.971,0,2.014-0.091,3.125-0.27c1.111-0.182,2.15-0.528,3.125-1.044c0.971-0.516,1.779-1.226,2.43-2.129
			c0.647-0.9,0.971-2.046,0.971-3.439c0-1.495-0.429-2.706-1.285-3.636c-0.859-0.926-1.98-1.7-3.367-2.319
			c-1.39-0.619-2.961-1.158-4.72-1.625c-1.762-0.463-3.541-0.975-5.347-1.545c-1.85-0.516-3.656-1.146-5.415-1.894
			c-1.758-0.748-3.333-1.712-4.72-2.9c-1.39-1.184-2.511-2.668-3.367-4.445c-0.859-1.78-1.285-3.932-1.285-6.456
			c0-2.835,0.542-5.299,1.632-7.386c1.087-2.088,2.508-3.826,4.266-5.219c1.758-1.393,3.748-2.422,5.97-3.093
			c2.222-0.668,4.444-1.006,6.665-1.006c2.59,0,5.077,0.323,7.463,0.968c2.382,0.645,4.502,1.689,6.352,3.131s3.319,3.287,4.41,5.53
			c1.087,2.239,1.629,4.961,1.629,8.157h-10.55c-0.095-1.651-0.406-3.018-0.937-4.099c-0.532-1.082-1.24-1.932-2.12-2.551
			c-0.879-0.619-1.884-1.055-3.019-1.313c-1.135-0.258-2.372-0.387-3.714-0.387c-0.879,0-1.758,0.102-2.638,0.307
			c-0.879,0.209-1.677,0.569-2.392,1.082c-0.719,0.516-1.309,1.161-1.772,1.936c-0.463,0.771-0.695,1.754-0.695,2.938
			c0,1.082,0.184,1.959,0.555,2.627c0.371,0.672,1.101,1.291,2.188,1.856c1.087,0.569,2.59,1.135,4.512,1.704
			c1.922,0.566,4.43,1.287,7.531,2.164c0.927,0.205,2.212,0.581,3.854,1.12c1.643,0.543,3.275,1.408,4.893,2.592
			c1.622,1.184,3.019,2.771,4.202,4.756c1.179,1.985,1.769,4.521,1.769,7.614c0,2.528-0.44,4.874-1.319,7.037
			s-2.188,4.035-3.922,5.606c-1.735,1.571-3.888,2.797-6.454,3.674c-2.569,0.873-5.544,1.313-8.921,1.313
			c-2.733,0-5.381-0.376-7.95-1.12c-2.566-0.748-4.836-1.921-6.802-3.519c-1.966-1.598-3.53-3.636-4.686-6.111
			c-1.159-2.475-1.714-5.413-1.666-8.814h10.55C76.776,228.003,77.079,229.575,77.679,230.865z"
          />
          <path
            fill="#011111"
            d="M146.197,203.992c-0.651-1.158-1.458-2.175-2.43-3.052c-0.971-0.877-2.072-1.56-3.299-2.05
			c-1.227-0.49-2.511-0.736-3.851-0.736c-2.454,0-4.539,0.531-6.25,1.587c-1.714,1.059-3.101,2.475-4.164,4.251
			c-1.067,1.78-1.84,3.803-2.327,6.073c-0.484,2.266-0.729,4.612-0.729,7.033c0,2.323,0.245,4.578,0.729,6.768
			c0.487,2.19,1.261,4.164,2.327,5.914c1.063,1.754,2.45,3.158,4.164,4.217c1.711,1.055,3.796,1.583,6.25,1.583
			c3.329,0,5.933-1.131,7.807-3.401c1.874-2.27,3.023-5.257,3.438-8.969h10.55c-0.276,3.454-0.995,6.57-2.15,9.356
			c-1.159,2.782-2.685,5.155-4.583,7.113c-1.898,1.959-4.12,3.454-6.662,4.486c-2.549,1.029-5.347,1.545-8.4,1.545
			c-3.796,0-7.211-0.736-10.24-2.205c-3.033-1.469-5.589-3.492-7.671-6.069s-3.68-5.606-4.791-9.083
			c-1.111-3.481-1.666-7.231-1.666-11.254c0-4.122,0.555-7.948,1.666-11.482c1.111-3.53,2.709-6.608,4.791-9.239
			c2.082-2.63,4.638-4.691,7.671-6.187c3.029-1.495,6.444-2.243,10.24-2.243c2.73,0,5.309,0.44,7.739,1.317s4.604,2.152,6.526,3.826
			c1.919,1.678,3.507,3.75,4.754,6.225c1.251,2.475,2.038,5.31,2.362,8.506h-10.55C147.26,206.429,146.845,205.153,146.197,203.992z
			"
          />
          <path
            fill="#011111"
            d="M176.74,189.265v21.187h20.061v-21.187h10.901v55.208h-10.901v-23.814H176.74v23.814h-10.898v-55.208
			L176.74,189.265L176.74,189.265z"
          />
          <path
            fill="#011111"
            d="M254.35,189.265v10.207h-26.171v11.831h24.024v9.432h-24.024v13.532h26.73v10.207h-37.628v-55.208
			L254.35,189.265L254.35,189.265z"
          />
          <path
            fill="#011111"
            d="M283.65,189.265c3.196,0,6.168,0.566,8.921,1.7c2.753,1.135,5.139,2.835,7.149,5.101
			c2.011,2.27,3.585,5.105,4.723,8.506c1.131,3.405,1.697,7.398,1.697,11.987c0,4.02-0.463,7.732-1.384,11.133
			c-0.927,3.405-2.331,6.343-4.205,8.817c-1.874,2.475-4.212,4.418-7.006,5.838c-2.801,1.416-6.1,2.126-9.896,2.126h-21.38v-55.208
			L283.65,189.265L283.65,189.265z M282.886,234.266c1.574,0,3.101-0.285,4.58-0.85c1.486-0.566,2.801-1.507,3.96-2.824
			c1.159-1.313,2.079-3.025,2.774-5.139s1.043-4.691,1.043-7.736c0-2.782-0.245-5.295-0.729-7.538s-1.281-4.16-2.392-5.758
			c-1.111-1.598-2.583-2.824-4.41-3.674c-1.827-0.85-4.082-1.275-6.768-1.275h-7.776v34.795h9.718V234.266z"
          />
          <path
            fill="#011111"
            d="M350.154,240.259c-3.748,3.632-8.928,5.451-15.546,5.451c-6.713,0-11.906-1.803-15.587-5.413
			c-3.68-3.61-5.52-9.174-5.52-16.701v-34.332h10.898v34.332c0,1.495,0.116,2.964,0.348,4.407s0.722,2.718,1.458,3.826
			c0.743,1.108,1.772,2.012,3.094,2.706c1.315,0.698,3.087,1.044,5.309,1.044c3.885,0,6.57-0.964,8.049-2.9
			c1.486-1.932,2.222-4.961,2.222-9.083v-34.332h10.898v34.332C355.777,231.07,353.903,236.623,350.154,240.259z"
          />
          <path fill="#011111" d="M376.046,189.265v45.001h24.161v10.207h-35.058v-55.208L376.046,189.265L376.046,189.265z" />
          <path
            fill="#011111"
            d="M443.382,189.265v10.207h-26.171v11.831h24.017v9.432h-24.017v13.532h26.73v10.207h-37.628v-55.208
			L443.382,189.265L443.382,189.265z"
          />
          <path
            fill="#011111"
            d="M17.322,267.656l11.593,37.964h0.14l10.966-37.964h15.341v55.208H45.159v-39.126h-0.14l-12.148,39.126
			h-8.4l-12.148-38.739h-0.14v38.739H1.98v-55.208H17.322z"
          />
          <path
            fill="#011111"
            d="M89.657,267.656l18.534,55.208H96.878l-3.752-12.294H74.591l-3.888,12.294H59.737l18.742-55.208H89.657z
			 M90.28,301.521l-6.246-20.257h-0.14l-6.454,20.257H90.28z"
          />
          <path fill="#011111" d="M123.393,267.656v55.208h-10.898v-55.208H123.393z" />
          <path
            fill="#011111"
            d="M143.805,267.656l20.685,37.038h0.14v-37.038h10.206v55.208h-10.901l-20.617-36.962h-0.14v36.962h-10.203
			v-55.208H143.805z"
          />
          <path fill="#011111" d="M180.526,277.863v-10.207h40.609v10.207h-14.854v45.001H195.38v-45.001H180.526z" />
          <path
            fill="#011111"
            d="M263.906,267.656v10.207h-26.178v11.831h24.024v9.432h-24.024v13.532h26.737v10.207H226.83v-55.208h37.076
			V267.656z"
          />
          <path
            fill="#011111"
            d="M282.648,267.656l20.685,37.038h0.143v-37.038h10.203v55.208H302.78l-20.617-36.962h-0.143v36.962h-10.203
			v-55.208H282.648z"
          />
          <path
            fill="#011111"
            d="M347.966,267.656l18.538,55.208h-11.32l-3.748-12.294h-18.531l-3.892,12.294h-10.966l18.742-55.208
			H347.966z M348.593,301.521l-6.25-20.257h-0.136l-6.461,20.257H348.593z"
          />
          <path
            fill="#011111"
            d="M381.641,267.656l20.685,37.038h0.143v-37.038h10.203v55.208h-10.898l-20.617-36.962h-0.143v36.962
			h-10.203v-55.208H381.641z"
          />
          <path
            fill="#011111"
            d="M454.041,282.384c-0.647-1.158-1.458-2.175-2.433-3.052c-0.968-0.877-2.072-1.56-3.292-2.05
			c-1.227-0.49-2.515-0.736-3.857-0.736c-2.454,0-4.532,0.531-6.243,1.587c-1.717,1.059-3.101,2.475-4.171,4.251
			c-1.063,1.78-1.84,3.803-2.324,6.073c-0.484,2.266-0.729,4.612-0.729,7.033c0,2.323,0.245,4.578,0.729,6.768
			s1.261,4.164,2.324,5.914c1.07,1.754,2.454,3.158,4.171,4.217c1.711,1.055,3.789,1.583,6.243,1.583
			c3.333,0,5.936-1.131,7.81-3.401s3.019-5.257,3.435-8.969h10.557c-0.279,3.454-0.995,6.57-2.154,9.356
			c-1.159,2.782-2.685,5.155-4.58,7.113c-1.901,1.959-4.123,3.454-6.665,4.486c-2.549,1.029-5.35,1.545-8.403,1.545
			c-3.796,0-7.204-0.736-10.237-2.205s-5.589-3.492-7.674-6.069c-2.079-2.577-3.68-5.606-4.784-9.083
			c-1.111-3.481-1.67-7.231-1.67-11.254c0-4.122,0.559-7.948,1.67-11.482c1.104-3.53,2.706-6.608,4.784-9.239
			c2.086-2.63,4.641-4.691,7.674-6.187c3.033-1.495,6.441-2.243,10.237-2.243c2.733,0,5.309,0.44,7.742,1.317
			c2.426,0.877,4.607,2.152,6.522,3.826c1.922,1.678,3.51,3.75,4.757,6.225c1.254,2.475,2.038,5.31,2.358,8.506h-10.55
			C455.104,284.82,454.688,283.545,454.041,282.384z"
          />
          <path
            fill="#011111"
            d="M510.759,267.656v10.207h-26.171v11.831h24.017v9.432h-24.017v13.532h26.73v10.207H473.69v-55.208h37.069
			V267.656z"
          />
        </g>
      </g>
    </svg>
  );
};

export default Icon;
